<template lang="html">
  <v-app>
    <section class="about">
      <SubTitle
        :TitleName="'http://d-mebius.com/miasmabreaker/assets/index_about.png'"
        :AltText="'ゲーム概要'"
      />
      <div class="story_page page-bottom" key="about_page">
        <SubTitle
          :TitleName="'http://d-mebius.com/miasmabreaker/assets/caption_01.png'"
          :AltText="'「宵祓い探偵 ミアズマブレイカー」とは'"
        />
        <div class="text-column">
          <p>
            全方位から襲い来る悪霊「ミアズマ」を撃破する爽快感とアクション性が高いツインスティックシューティングです。<br />
            操作キャラの通常攻撃、連れている守護霊の守護霊攻撃、様々な除霊スキルを組み合わせてプレイスタイルに合わせたキャラクタービルドが可能です。<br />
            ピクセルアートと3Dを融合させた世界の中で次々と現れるミアズマを撃破しよう！
          </p>
        </div>
        <v-container>
          <v-row class="justify-center">
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss01.png"
                @click="openDialog('ss01')"
              ></v-img>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss02.png"
                @click="openDialog('ss02')"
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss03.png"
                @click="openDialog('ss03')"
              ></v-img>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-img
                width="480"
                src="http://d-mebius.com/miasmabreaker/assets/ss04.png"
                @click="openDialog('ss04')"
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </section>
    <v-dialog v-model="dialog" max-width="1280">
      <v-img
        :src="
          'http://d-mebius.com/miasmabreaker/assets/' + selectedImage + '.png'
        "
      ></v-img>
    </v-dialog>
  </v-app>
</template>

<style></style>
<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    data() {
      return {
        dialog: false,
        selectedImage: "",
      };
    },
    methods: {
      openDialog(imageName) {
        this.selectedImage = imageName;
        console.log(this.selectedImage); // ここで値を確認
        this.dialog = true;
      },
    },
  };
</script>
